import { Component, OnInit, ViewChild } from '@angular/core';
import { BecareService } from 'src/app/services/becare.service';
import { LegacyContentService } from 'src/app/services/legacy-content.service';
import { PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { environment } from 'src/environments/environment';
import { LegacyContentComponent } from '../legacy-content/legacy-content.component';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {

  constructor(public becare: BecareService, private patient: PatientService,
              private userConfig: UserConfigService, private legacyContent: LegacyContentService) {
    this.becare.authStatus().subscribe(status => {
      if (status === false) {
        console.log('LOGIN PANEL');
        this.redirectToLogin();
      }
    });
    this.patient.patientSelectedEvent.subscribe(() => {
      const patientFirstComponent = this.userConfig.profileValue('CNUser', 'patient_first_component');
      if (patientFirstComponent) {
        this.legacyContent.SetComponent(patientFirstComponent as string);
      }
    });
  }

  ngOnInit(): void {
    this.becare.autoAuthenticate().subscribe(user => {
      console.log('auto authenticated', user);
    }, error => {
      console.log('not authenticated ... open login panel');
      // Open Login panel
      console.log('Opening login panel');
      this.redirectToLogin();
    });
  }

  redirectToLogin() {
    console.log('LOGIN PANEL');
    // Redirect to login url
    window.location.href = window.location.protocol + '//sso.' + window.location.host;
  }
}
